import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { MenuItem, Dropdown } from 'react-bootstrap';
import AccountDetailsBL from '../financial-stories/AccountDetailsNew/AccountDetailsBL';
import StringConstant from '../../constants/StringConstants';
import { isCB, isYB, isVMBusiness } from '../../utils/BrandUtils';

class AccountDropDownComponent extends React.Component {
  constructor(props) {
    super(props);
    this.setSelectedDropdownMessage =
      this.setSelectedDropdownMessage.bind(this);
    this.displayAccountDropDown = this.displayAccountDropDown.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.state = {
      accountName: 'Select an account',
      accountNumber: null,
      hasLargeCustomerView: isCB() || isYB() || isVMBusiness(),
    };
  }
  componentDidMount() {
    const { selectedAccount } = this.props;
    if (selectedAccount) {
      this.setSelectedDropdownMessage(selectedAccount);
    }
  }
  componentWillReceiveProps(newProps) {
    if (newProps.selectedAccount !== this.props.selectedAccount) {
      this.setSelectedDropdownMessage(newProps.selectedAccount);
    }
  }
  onSelect(e) {
    this.props.onDropdownSelect(e);
  }
  setSelectedDropdownMessage(selectedAccount) {
    if (selectedAccount === StringConstant.ALL) {
      this.setState({
        accountName: selectedAccount,
        accountNumber: null,
      });
    } else {
      const accountNumber =
        AccountDetailsBL.getAccountDisplayNumber(selectedAccount);
      this.setState({
        accountName: selectedAccount.displayName,
        accountNumber,
      });
    }
  }
  displayAccountDropDown() {
    const { hasLargeCustomerView } = this.state;
    const { accountList = [] } = this.props;
    const dropDown = accountList.map((account, index) => (
      <MenuItem
        eventKey={account.id}
        onSelect={this.onSelect}
        key={`displayAccountDropDown_MenuItem_${account.id}_${index}`}
      >
        {hasLargeCustomerView && (
          <span>{get(account, 'metadata.account_name', '')}</span>
        )}
        <span className="account-name" aria-labelledby="Account Name">
          {account.displayName}
        </span>
        <span className="account-number">
          <span className="u-visually-hidden off-screen">
            Account Sort Code and Account Number{' '}
          </span>
          {AccountDetailsBL.getAccountDisplayNumber(account)}
        </span>
      </MenuItem>
    ));
    dropDown.push(
      <MenuItem eventKey={StringConstant.ALL} onSelect={this.onSelect}>
        <span className="account-name" aria-labelledby="All Accounts">
          {StringConstant.ALL}
        </span>
      </MenuItem>
    );
    return dropDown;
  }
  render() {
    const { accountNumber, accountName } = this.state;
    return (
      <div className="btn-toolbar c-payment-history_account-dropdown">
        <Dropdown className="custom-dropdown">
          <Dropdown.Toggle
            noCaret
            className="custom-dropdown__btn accountDropdown_btn"
            id="selected-account"
          >
            <span
              className="btn--title btn--title--multiline btn--title--multiline--withpadding"
              aria-labelledby="selected accountName accountDetails"
            >
              <span className="account-name">{accountName}</span>
              {accountNumber && (
                <span className="account-number">
                  <span className="u-visually-hidden off-screen">
                    Account Sort Code and Account Number{' '}
                  </span>
                  {accountNumber}
                </span>
              )}
            </span>
            <span className="symbol">
              <svg width="32" height="61" viewBox="0 0 32 32" role="img">
                <path d="M19.55 12.602l1.884 1.833-5.717 5.565-5.717-5.565 1.883-1.833 3.833 3.731z" />
              </svg>
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdowm-menu--scroll dropdowm-menu--z-index">
            {this.displayAccountDropDown()}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}
AccountDropDownComponent.propTypes = {
  selectedAccount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
    }),
  ]),
  onDropdownSelect: PropTypes.func,
  accountList: PropTypes.array,
};

AccountDropDownComponent.defaultProps = {
  selectedAccount: {
    id: 11111,
    displayName: 'Account Name',
    accountNumber: '00000000',
    sortCode: '000000',
  },
};

export default AccountDropDownComponent;
